<template>
    <tr>
        <td>
            <v-select
                :items="productTypes"
                item-value="id"
                item-text="text"
                v-model="internalValue.type"
                :error-messages="errorMessages(`products.${index}.type`)"
                :class="{ 'error--text': hasErrors(`products.${index}.type`) }"
                class="primary--text"
                :name="`products.${index}.type`"
                label="Tip produs"
                data-vv-as="Tip produs"
                :data-vv-name="`products.${index}.type`"
            />
        </td>
        <td>
            <product-combo-box
                v-model="internalValue.id"
                :initial-items="[internalValue]"
                :field-errors="errorMessages(`products.${index}.name`)"
                @change="handleProductLineChange($event)"
            />
        </td>
        <td>
            <!--                                            <input type="text" v-model.lazy="internalValue.product_number"/>-->
            <v-offer-row-field
                v-model="internalValue.product_number"
                :error-messages="errorMessages(`products.${index}.product_number`)"
                :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.product_number`) }"
                data-vv-as="Cod produs"
                :data-vv-name="`products.${index}.product_number`"
            />
        </td>
        <td>
            <!--                                            <input type="text" v-model.lazy="internalValue.quantity"/>-->
            <v-offer-row-field
                v-model="internalValue.quantity"
                :error-messages="errorMessages(`products.${index}.quantity`)"
                :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.quantity`) }"
                data-vv-as="Cantitate"
                :data-vv-name="`products.${index}.quantity`"
                type="number"
            />
        </td>
        <td>
            <v-select
                :items="productMeasurements"
                v-model="internalValue.measurement"
                :error-messages="errorMessages(`products.${index}.measurement`)"
                :class="{ 'error--text': hasErrors(`products.${index}.measurement`) }"
                class="primary--text input-text-right"
                :name="`products.${index}.measurement`"
                label="U.M."
                data-vv-as="U.M."
                :data-vv-name="`products.${index}.measurement`"
            />
        </td>
        <td v-if="isCurrency">
            <!--                                            <input type="text" v-model.lazy="internalValue.unit_price_currency"/>-->
            <v-offer-row-field
                v-model="internalValue.unit_price_currency"
                :error-messages="errorMessages(`products.${index}.unit_price_currency`)"
                :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.unit_price_currency`) }"
                data-vv-as="Valuta pret unitar"
                :data-vv-name="`products.${index}.unit_price_currency`"
                type="number"
            />
        </td>
        <td>
            <!--                                            <input type="text" v-model.lazy="internalValue.unit_price"/>-->
            <v-offer-row-field
                v-model="internalValue.unit_price"
                :error-messages="errorMessages(`products.${index}.unit_price`)"
                :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.unit_price`) }"
                data-vv-as="PU ofertat"
                :data-vv-name="`products.${index}.unit_price`"
                type="number"
            />
        </td>
        <td>
            <!--                                            <input type="text" v-model.lazy="internalValue.unit_price"/>-->
            <v-offer-row-field
                v-model="internalValue.unit_price_with_vat"
                :error-messages="errorMessages(`products.${index}.unit_price_with_vat`)"
                :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.unit_price_with_vat`) }"
                data-vv-as="PU ofertat cu TVA"
                :data-vv-name="`products.${index}.unit_price_with_vat`"
                type="number"
            />
        </td>
        <td v-if="isCurrency">
            <!--                                            <input type="text" v-model.lazy="internalValue.entry_amount_currency"/>-->
            <v-offer-row-field
                v-model="internalValue.entry_amount_currency"
                :error-messages="errorMessages(`products.${index}.entry_amount_currency`)"
                :class="{'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.entry_amount_currency`) }"
                data-vv-as="Valuta cost unitar"
                :data-vv-name="`products.${index}.entry_amount_currency`"
                type="number"
            />
        </td>
        <td>
            <!--                                            <input type="text" v-model.lazy="internalValue.entry_amount"/>-->
            <v-offer-row-field
                v-model="internalValue.entry_amount"
                :error-messages="errorMessages(`products.${index}.entry_amount`)"
                :class="{'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.entry_amount`) }"
                data-vv-as="Cost unitar"
                :data-vv-name="`products.${index}.entry_amount`"
                type="number"
            />
        </td>
        <td>
            <supplier-modal
                v-model="internalValue.supplier_id"
                :initial-items="[internalValue.supplier]"
                :field-errors="errorMessages(`products.${index}.supplier_id`)"
                inline/>
        </td>
        <td>
            <!--                                            <input type="text" v-model.lazy="internalValue.transport_cost"/>-->
            <v-offer-row-field
                v-model="internalValue.transport_cost"
                :error-messages="errorMessages(`products.${index}.transport_cost`)"
                :class="{'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.transport_cost`) }"
                data-vv-as="Cost transp."
                :data-vv-name="`products.${index}.transport_cost`"
                type="number"
            />
        </td>
        <td>
            <!--                                            <input type="text" v-model.lazy="internalValue.delivery_time"/>-->
            <v-offer-row-field
                v-model="internalValue.delivery_time"
                :error-messages="errorMessages(`products.${index}.delivery_time`)"
                :v-class="{'primary--text input-text-right': true, 'error--text': hasErrors(`products.${index}.delivery_time`) }"
                class="primary--text input-text-right"
                data-vv-as="Termen livr."
                :data-vv-name="`products.${index}.delivery_time`"
            />
        </td>
        <td>
            <v-btn
                :disabled="!canEdit"
                class="ma-2 pull-right"
                color="error"
                outlined
                x-small
                fab
                @click="$emit('delete')"
            >
                <v-icon>mdi-trash-can</v-icon>
            </v-btn>
        </td>
    </tr>
</template>

<script>
import ProductComboBox from 'Components/modal/ProductComboBox'
import SupplierModal from 'Components/modal/SupplierModal'
export default {
    name: 'VOfferRow',
    components: {
        ProductComboBox,
        SupplierModal
    },
    props: {
        value: {
            type: Object,
            default() {
                return {
                    id: null,
                    type: null,
                    name: null,
                    product_number: null,
                    quantity: 1,
                    measurement: 'BUC',
                    entry_amount_currency: 0,
                    entry_amount: 0,
                    transport_cost: 0,
                    supplier_id: null,
                    unit_price: 0,
                    unit_price_with_vat: 0,
                    unit_price_currency: 0,
                    delivery_time: 0
                }
            }
        },
        index: {
            type: Number,
            default() {
                return null
            }
        },
        isCurrency: {
            type: Boolean,
            default() {
                return false
            }
        },
        canEdit: {
            type: Boolean,
            default() {
                return true
            }
        },
        hasErrors: {
            type: Function,
            default () {
                return () => {

                }
            }
        },
        errorMessages: {
            type: Function,
            default () {
                return () => {

                }
            }
        }
    },
    watch: {
        value: {
            handler (val) {
                this.internalValue = val
            },
            deep: true
        },
        'internalValue.unit_price': {
            handler (val) {
                this.internalValue.unit_price_with_vat = (parseFloat(val) * this.$db.Invoice.VAT_RATE_MULTIPLIER).toFixed(2)
            }
        },
        'internalValue.unit_price_with_vat': {
            handler (val) {
                this.internalValue.unit_price = (parseFloat(val) / this.$db.Invoice.VAT_RATE_MULTIPLIER).toFixed(2)
            }
        },
        internalValue: {
            handler (val) {
                this.$emit('input', val)
            },
            deep: true
        }
    },
    data () {
        return {
            internalValue: this.value,
            productTypes: [],
            productMeasurements: [],
        }
    },
    methods: {
        handleProductLineChange(ev) {
            if (!this._.isNil(ev)) {
                if (ev instanceof Object) {
                    this.internalValue.id = ev.id
                    this.internalValue.type = ev.type
                    this.internalValue.name = ev.name
                    this.internalValue.product_number = ev.product_number
                } else {
                    if (!this._.isNil(this.internalValue.id)) {
                        this.internalValue.id = null
                        this.internalValue.type = null
                        this.internalValue.product_number = null
                    }
                    this.internalValue.name = ev
                }
                this.$validator.reset();
                this.$validator.validateAll()
            }
        }
    },
    async mounted() {
        this.productMeasurements = (new this.$db.OfferProduct).measurements
        this.productTypes = (new this.$db.Product).productTypes
    }
    /*
    beforeUpdate() {
        console.log('beforeUpdate', this.index)
    },
    updated() {
        console.log('updated', this.index)
    }
    */
}
</script>
